import { gql } from '@apollo/client'

export const SIGNUP = gql`
  mutation SignUp($token: String!, $inputData: EditUserInput!) {
    signUp(token: $token, inputData: $inputData)
  }
`
